import React from "react";
import { Row } from "react-bootstrap";
import "./TopBar.css";

const TopBar = () => {
  return (
    <div className="container-fluid top-bar-container">
      <div className="container">
        <Row>
          <div className="top-bar d-flex align-item-center align-content-center">
            <svg
              width={22}
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              />
            </svg>
            <p className="top-bar-text">
              2480 Newberry Rd Waterford, Michigan(MI), 48329, United States
            </p>
            <aside className="d-flex top-bar-contact">
              <p>
                <svg
                  width={22}
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:01911411270">+880 1911 411 270</a>
              </p>
              <p>
                <svg
                  width={22}
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a href="mailto:rahmandevbd@gmail.com">support@yougafit.com</a>
              </p>
            </aside>
          </div>
        </Row>
      </div>
    </div>
  );
};

export default TopBar;
